export const SkipLinkingSSOQueryKey = 'slsso';
